// Header.js
// Accepts optional `activePage` prop: "home" | "about" | "services" | "liveevent" | "contact"

function Header({ activePage = "home" }) {
  return (
    <header className="main-header">
      <div className="header-content">

        {/* LEFT: Logo + Title */}
        <div className="logo-section">
          <div className="logo">
            <img src="/logo.jpg" alt="University of Peradeniya Logo" />
          </div>
          <div className="site-title">
            <h1 style={{ fontFamily: "'Playfair Display', serif" }}>
              Media &amp; Community <span>Relations Centre</span>
            </h1>
            <p style={{ fontFamily: "'DM Sans', sans-serif" }}>University of Peradeniya</p>
          </div>
        </div>

        {/* RIGHT: Navigation */}
        <nav style={{
          display: "flex",
          alignItems: "center",
          gap: "4px",
          flexWrap: "nowrap",
          marginLeft: "auto",
          fontFamily: "'DM Sans', sans-serif"
        }}>

          <div className="nav-item">
            <a href="/" className={`nav-link${activePage === "home" ? " active" : ""}`}>
              Home
            </a>
          </div>

          <div className="nav-item">
            <a href="#about" className={`nav-link${activePage === "about" ? " active" : ""}`}>
              About <span className="dropdown-icon">&#9660;</span>
            </a>
            <div className="dropdown-menu">
              <a href="/management">Management Committee</a>
              <a href="/staff">Staff</a>
            </div>
          </div>

          <div className="nav-item">
            <a href="/#services" className={`nav-link${activePage === "services" ? " active" : ""}`}>
              Our Services
            </a>
          </div>

          <div className="nav-item">
            <a href="/liveevent" className={`nav-link${activePage === "liveevent" ? " active" : ""}`}>
              Live Event Coverage
            </a>
          </div>

          <div className="nav-item">
            <a href="/#contact" className={`nav-link${activePage === "contact" ? " active" : ""}`}>
              Contact
            </a>
          </div>

        </nav>

      </div>
    </header>
  );
}

export default Header;